<template>
  <section>
    <v-data-table
      :headers="visibleHeaders"
      :items="items"
      :pagination.sync="pagination"
      hide-actions
      :custom-sort="customSort ? customSort : undefined"
      class="v-table-wrapper"
      :class="{ '-clickable': computedClickable }"
      :search="search"
      :no-data-text="
        (noDataText && noDataText.length) > 0 ? noDataText : undefined
      "
    >
      <template #headers='{ headers, all, indeterminate }' >
        <slot name='headers'
          :headers='headers'
          :all='all'
          :indeterminate="indeterminate"
          :pagination="pagination"
          :changeSort="changeSort"
        >
          <tr tabindex="0">
            <th
              v-for="header in headers"
              :key="header.text"
              tabindex="0"
              :class="['column sortable', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
              @click="changeSort(header.value)"
            >
              <v-icon small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </tr>
        </slot>
      </template>
      <template #items="{ item, index, selected, expanded }" >
        <slot
          name="items"
          :item="item"
          :index="index"
          :selected="selected"
          :expanded="expanded"
          :visibleHeaders="visibleHeaders"
          :getCellValue="getCellValue"
        >
          <router-link
            v-if="routedData"
            :to="item.route"
            tag="tr"
            tabindex="0"
            class="routed-row"
          >
            <td
              tabindex="0"
              v-for="(header, j) in visibleHeaders"
              :key="j"
              @keyup.enter="$emit('cellClicked', item)"
              @click="$emit('cellClicked', item)"
            >
              <template v-if="header.value == 'route'">
                <router-link
                  tabindex="0"
                  :to="item.route">{{ header.text  }}</router-link>
              </template>
              <template v-else>
                {{ getCellValue(item, header) }}
              </template>
            </td>
          </router-link>

          <tr
           v-else
           @keyup.enter="$emit('cellClicked', item)"
           tabindex="0"
           >
            <template v-for="(header, j) in visibleHeaders">
              <name-id-concat
                v-if="header.truncate"
                :key="j"
                tabindex="0"
                :value="getCellValue(item, header)"
                tag="td"
              />

              <td
                v-else
                @keyup.enter="$emit('cellClicked', item)"
                @click="$emit('cellClicked', item)"
                :key="`alt-${j}`"
                tabindex="0"
                >
                {{ getCellValue(item, header) }}
              </td>
            </template>
          </tr>
        </slot>
      </template>
    </v-data-table>
    <div class="text-xs-center pt-2" v-if="pages > 1">
      <v-pagination v-model="pagination.page" :length="pages"/>
    </div>
  </section>
</template>

<script>
  import { isFunction } from '@/utils'
  import NameIdConcat from '@atoms/ConcatAndEllipseValues.vue'

  export default {
    components: {
      NameIdConcat
    },
    props: {
      sortBy: String,
      descending: Boolean,
      headers: {
        type: Array,
        default: () => [],
      },
      items: Array,
      search: String,
      clickable: Boolean,
      rowsPerPage: {
        type: Number,
        default: 10
      },
      routedData: {
        type: Boolean,
        default: false
      },
      pathKey: {
        type: String
      },
      noDataText: {
        type: String,
        default: 'No data available'
      },
      customSort: Function
    },
    data() {
      return {
        pagination: {
          page: 1,
          rowsPerPage: 10,
          totalItems: 0
        }
      }
    },
    watch: {
      items: function(val) {
        this.$set(this.pagination, 'totalItems', val.length);
        // console.log(`pagination`, this.pagination);
      }
    },
    computed: {
      computedClickable() {
        return this.clickable || (this.$listeners && this.$listeners.cellClicked)
      },
      visibleHeaders() {
        let initialHeaders = this.headers.filter(
          h => (h.visible === undefined || h.visible) && !h.alwaysVisible
        )
        let alwaysVisibleHeaders = this.headers.filter(h => h.alwaysVisible)
        return [...initialHeaders, ...alwaysVisibleHeaders]
      },
      pages() {
        if (
          this.pagination.rowsPerPage == null ||
          this.pagination.totalItems == null
        ) {
          return 0
        }

        return Math.ceil(
          this.pagination.totalItems / this.pagination.rowsPerPage
        )
      }
    },
    created() {
      if (this.items) {
        this.$set(this.pagination, 'totalItems', this.items.length)
      }

      if (this.sortBy) { this.$set(this.pagination, 'sortBy', this.sortBy) }

      this.$set(this.pagination, 'descending', this.descending)
      this.$set(this.pagination, 'rowsPerPage', this.rowsPerPage)
      // console.log(`pagination`, this.pages);
    },
    methods: {
      getCellValue(item, header) {
        if (isFunction(header.value)) return header.value(item)
        else return item[header.value]
      },
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      }
    }
  }
</script>
